import React, { useState } from 'react';
import { PlusCircle, Edit2, Trash2 } from 'lucide-react';

const Blogs = () => {
  const [blogs, setBlogs] = useState([
    {
      id: 1,
      title: 'Getting Started with Online Tutoring',
      author: 'John Doe',
      status: 'published',
      date: '2024-03-15',
      excerpt: 'Learn the basics of online tutoring and how to get started...',
    },
    {
      id: 2,
      title: 'Best Practices for Virtual Learning',
      author: 'Jane Smith',
      status: 'draft',
      date: '2024-03-14',
      excerpt: 'Discover the most effective strategies for virtual learning...',
    }
  ]);

  const [newBlog, setNewBlog] = useState({ title: '', author: '', excerpt: '', status: 'draft' });
  const [editingBlog, setEditingBlog] = useState(null);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewBlog({ ...newBlog, [name]: value });
  };

  // Handle adding a new blog
  const handleAddBlog = () => {
    if (!newBlog.title || !newBlog.author || !newBlog.excerpt) {
      alert('All fields are required.');
      return;
    }

    if (editingBlog) {
      // Update the blog
      setBlogs(blogs.map((blog) => (blog.id === editingBlog.id ? { ...newBlog, id: blog.id, date: blog.date } : blog)));
      setEditingBlog(null);
    } else {
      // Add a new blog
      setBlogs([...blogs, { ...newBlog, id: blogs.length + 1, date: new Date().toISOString().split('T')[0] }]);
    }

    setNewBlog({ title: '', author: '', excerpt: '', status: 'draft' });
  };

  // Handle editing a blog
  const handleEditBlog = (blog) => {
    setNewBlog(blog);
    setEditingBlog(blog);
  };

  // Handle deleting a blog
  const handleDeleteBlog = (id) => {
    setBlogs(blogs.filter((blog) => blog.id !== id));
  };

  return (
    <div className="space-y-6">
      {/* Add/Edit Blog Form */}
      <div className="bg-white shadow rounded-lg p-6">
        <h2 className="text-lg font-medium text-gray-900">{editingBlog ? 'Edit Blog' : 'New Blog'}</h2>
        <div className="mt-4 space-y-4">
          <input
            type="text"
            name="title"
            placeholder="Title"
            value={newBlog.title}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
          />
          <input
            type="text"
            name="author"
            placeholder="Author"
            value={newBlog.author}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
          />
          <textarea
            name="excerpt"
            placeholder="Excerpt"
            value={newBlog.excerpt}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
          />
          <select name="status" value={newBlog.status} onChange={handleChange} className="w-full p-2 border rounded-lg">
            <option value="draft">Draft</option>
            <option value="published">Published</option>
          </select>
          <button onClick={handleAddBlog} className="w-full bg-blue-600 text-white p-2 rounded-lg hover:bg-blue-700">
            {editingBlog ? 'Update Blog' : 'Add Blog'}
          </button>
        </div>
      </div>

      {/* Blog List */}
      <div className="bg-white shadow rounded-lg overflow-hidden">
        <div className="grid grid-cols-1 gap-4 sm:gap-6 p-6">
          {blogs.map((blog) => (
            <div key={blog.id} className="flex flex-col sm:flex-row sm:items-center justify-between p-4 border rounded-lg">
              <div className="flex-1">
                <h3 className="text-lg font-medium text-gray-900">{blog.title}</h3>
                <p className="mt-1 text-sm text-gray-500">{blog.excerpt}</p>
                <div className="mt-2 flex items-center text-sm text-gray-500">
                  <span>By {blog.author}</span>
                  <span className="mx-2">•</span>
                  <span>{blog.date}</span>
                  <span className="mx-2">•</span>
                  <span
                    className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                      blog.status === 'published' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'
                    }`}
                  >
                    {blog.status}
                  </span>
                </div>
              </div>
              <div className="mt-4 sm:mt-0 sm:ml-4 flex items-center space-x-4">
                <button onClick={() => handleEditBlog(blog)} className="text-blue-600 hover:text-blue-900">
                  <Edit2 className="h-5 w-5" />
                </button>
                <button onClick={() => handleDeleteBlog(blog.id)} className="text-red-600 hover:text-red-900">
                  <Trash2 className="h-5 w-5" />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blogs;
